import { render, staticRenderFns } from "./GroupManagementRegistration.vue?vue&type=template&id=88d324d2&scoped=true&"
import script from "./GroupManagementRegistration.vue?vue&type=script&lang=js&"
export * from "./GroupManagementRegistration.vue?vue&type=script&lang=js&"
import style0 from "./GroupManagementRegistration.vue?vue&type=style&index=0&id=88d324d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d324d2",
  null
  
)

export default component.exports